import { MouseEvent } from "react";
import { BsDownload } from "react-icons/bs";
import { GoPackage } from "react-icons/go";
import { IoShareSocial } from "react-icons/io5";
import cn from "classnames";
import SmallLoader from "@components/SmallLoader/SmallLoader";

interface MacsListActionsProps {
    id: number;
    index: number;
    isDownloading: boolean;
    onAddToPackage: () => void;
    onShare: () => void;
}

const stopRowInteraction = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
};

const MacsListActions = ({ id, index, isDownloading, onAddToPackage, onShare }: MacsListActionsProps) => (
    <div className="MacsListTable__actions" onClick={stopRowInteraction}>
        <button
            type="button"
            className={cn("MacsListTable__action", isDownloading && "is-disabled")}
            title="Download"
            disabled={isDownloading}
            data-tooltip-id={`macs-list-table-item-download-${id}`}
            data-testid={`buttonMacsDownload-${index}`}
        >
            {isDownloading
                ? <SmallLoader className="MacsListTable__action-loader"/>
                : <BsDownload/>}
        </button>
        <button
            type="button"
            className="MacsListTable__action is-clickable"
            title="Add to package"
            onClick={onAddToPackage}
            data-testid={`buttonMacsAddToPackage-${index}`}
        >
            <GoPackage/>
        </button>
        <button
            type="button"
            className="MacsListTable__action is-clickable"
            title="Share"
            onClick={onShare}
            data-testid={`buttonMacsShare-${index}`}
        >
            <IoShareSocial/>
        </button>
    </div>
);

export default MacsListActions;
